import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./style.scss";
import uris from "../../../config/uris";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import PlaybookMain, { fetchStoredTabs } from "../../esg-chat/playbooks";
import CustomTab from "../../../assets/component/tab";

const tabOptions = {
    key: 1,
    title: 'Regulations',
    value: 'regulations',
    tabs: [
        {
            key: 1.1,
            title: 'SFDR',
            payloadType: "SFDR",
        },
        {
            key: 1.2,
            title: 'DNSH',
            payloadType: "DNSH",
        },
        {
            key: 1.3,
            title: 'BRSR',
            payloadType: "BRSR",
        },
    ]
}

const Regulations = () => {
    const [questionInput, setQuestionInput] = useState("");
    const [presetQuestion, setPresetQuestion] = useState("");
    const [playbookDetails, setPlaybookDetails] = useState({})
    const [activeTab, setActiveTab] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const storedTabs = fetchStoredTabs({ playbookName: tabOptions?.title })

        if (storedTabs) {
            const filteredTabOptions = {
                ...tabOptions,
                tabs: tabOptions.tabs.filter(tab => storedTabs?.includes(tab.title))
            };

            setPlaybookDetails(filteredTabOptions)
            setActiveTab(filteredTabOptions?.tabs[0]?.payloadType)
        } else {
            setPlaybookDetails(tabOptions)
            setActiveTab(tabOptions?.tabs[0]?.payloadType)
        }
    }, [setPlaybookDetails, setActiveTab])

    useEffect(() => {
        if (questionInput) {
            navigate(uris.companyResearch, { state: { question: questionInput, presetQuestion: presetQuestion } });
        }
    }, [presetQuestion, questionInput])

    return (
        <div className="regulations-playbook-container">
            <Breadcrumbs />
            <CustomTab tabOptions={playbookDetails} setTabValue={setActiveTab} tabValue={activeTab}>
                {activeTab && (
                    <div className="playbook-contents">
                        <PlaybookMain
                            promptType={activeTab}
                            setQuestionInput={setQuestionInput}
                            setPresetQuestion={setPresetQuestion}
                        />
                    </div>
                )}
            </CustomTab>
        </div>
    )
}

export default Regulations;